import { GET_LOADING } from "../../actions/actionTypes";

export const LoadingReducer = (state = false, action) => {
  switch (action.type) {
    case GET_LOADING:
      return action.payload;
    default:
      return state;
  }
};
